/* eslint-disable no-loop-func */
/* eslint-disable no-func-assign */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _venturaSlider = require("ventura-slider");

require("ventura-slider/dist/tiny-slider.css");

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor
              ? Object.getOwnPropertyDescriptor(obj, key)
              : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === "function" &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? "symbol"
        : typeof obj;
    };
  }
  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(
        Object.getOwnPropertySymbols(source).filter(function(sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        })
      );
    }
    ownKeys.forEach(function(key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf(o, p);
}

/**
 * Wrapper component to show carousel, controlling the lifecycle
 * methods and settings update.
 * @param {object} settings - setting to configure tiny-slider plugin
 * @param {function} onClick - callback to return slide clicked
 * @param {number} startIndex - index of carousel initiation
 *
 * @param {function} onIndexChanged - event bind
 * @param {function} onTransitionStart - event bind
 * @param {function} onTransitionEnd - event bind
 * @param {function} onTouchStart - event bind
 * @param {function} onTouchMove - event bind
 * @param {function} onTouchEnd - event bind
 *
 * @returns {ReactElement}
 */
var Carousel =
  /*#__PURE__*/
  (function(_Component) {
    _inherits(Carousel, _Component);

    function Carousel(props) {
      var _this;

      _classCallCheck(this, Carousel);

      _this = _possibleConstructorReturn(
        this,
        _getPrototypeOf(Carousel).call(this, props)
      );
      _this.state = {
        defaultSettings: {
          responsive: {},
          controlsText: ["◀", "▶"]
        }
      };
      _this.slider = null;
      _this.build = _this.build.bind(_assertThisInitialized(_this));
      _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
      _this.dragging = false;
      _this.mergedSettings = 0;
      _this.count = 0;
      return _this;
    }
    /**
     * Fire click on carousel when no draggin and call the onClick callback on prop
     */

    _createClass(Carousel, [
      {
        key: "onClick",
        value: function onClick(event) {
          var onClick = this.props.onClick;
          if (this.dragging || !onClick) return; // when only one element the slider doesnt init

          if (!this.slider) return onClick(null, null, event);
          var info = this.slider.getInfo();
          var slideClicked = info.slideItems[info.index]; // call click callback wiht info and slide clicked

          onClick(slideClicked, info, event);
        }
        /** * Initialize the carousel plugin with new settings */
      },
      {
        key: "build",
        value: function build() {
          var _this2 = this;

          var settings =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : {};
          if (this.slider) this.slider.destroy();
          /* INIT CAROUSEL */

          this.mergedSettings = _objectSpread(
            {},
            this.state.defaultSettings,
            settings,
            {
              container: this.ref,
              onInit: function onInit() {
                _this2.postInit();
              }
            }
          );
          this.slider = (0, _venturaSlider.tns)(this.mergedSettings); // call events binding

          if (this.slider) return; // if the slider doesn't load because there is just a child
          // so add class to normal behavior

          if (this.ref) this.ref.className += " tns-item"; // so if there is lazy load active load src manually

          if (this.mergedSettings.lazyload) {
            [].forEach.call(this.ref.querySelectorAll("img"), function(img) {
              if (img.dataset.src) {
                img.src = img.dataset.src;
                img.className += " loaded";
              }
            });
          }
        }
        /**
         * Once the slider plugins has been initialized
         */
      },
      {
        key: "postInit",
        value: function postInit() {
          var _this3 = this;

          if (!this.slider) {
            if (this.count >= 4) {
              return this.props.onInit(false); // call initMetod anyway
            }

            this.count++;
            return setTimeout(this.postInit.bind(this), 100);
          }

          this.count = 0;
          var _this$slider = this.slider,
            events = _this$slider.events,
            goTo = _this$slider.goTo;
          var _this$props = this.props,
            onIndexChanged = _this$props.onIndexChanged,
            onTransitionStart = _this$props.onTransitionStart,
            onTransitionEnd = _this$props.onTransitionEnd,
            onTouchStart = _this$props.onTouchStart,
            onTouchMove = _this$props.onTouchMove,
            onTouchEnd = _this$props.onTouchEnd,
            startIndex = _this$props.startIndex,
            onInit = _this$props.onInit;
          /* BIND EVENTS */
          // change draggin value to purge onClick event.

          events.on("transitionStart", function(info) {
            _this3.dragging = true;
            if (onTransitionStart) onTransitionStart(info);
          });
          events.on("transitionEnd", function(info) {
            _this3.dragging = false;
            if (onTransitionEnd) onTransitionEnd(info);
          });
          if (onIndexChanged) events.on("indexChanged", onIndexChanged);
          if (onTouchStart) events.on("touchStart", onTouchStart);
          if (onTouchMove) events.on("touchMove", onTouchMove);
          if (onTouchEnd) events.on("touchEnd", onTouchEnd);
          /* GO TO START SLIDE */

          if (startIndex) {
            goTo(startIndex);
          } // call on Innit

          onInit(true);
        }
        /* LIFECYCLE EVENTS */
      },
      {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.build(this.props.settings);
        }
      },
      {
        key: "UNSAFE_componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          if (
            !(0, _utils.ObjectsEqual)(
              nextProps.settings,
              this.props.settings
            ) ||
            !(0, _utils.ChildrenEqual)(nextProps.children, this.props.children)
          ) {
            // prepare to reinitialization
            if (this.slider) {
              this.slider.destroy();
              this.slider = null;
            }
          }
        }
      },
      {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          if (!this.slider) {
            // rebuild in case to doesn exists
            this.build(this.props.settings);
          }
        }
      },
      {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.slider) this.slider.destroy();
        }
      },
      {
        key: "render",
        value: function render() {
          var _this4 = this;

          var _this$props2 = this.props,
            children = _this$props2.children;

          return _react["default"].createElement(
            "div",
            {
              ref: function ref(ele) {
                return (_this4.ref = ele);
              },
              onClick: this.onClick
            },
            children
          );
        }
      }
    ]);

    return Carousel;
  })(_react.Component);

Carousel.propTypes = {
  settings: _propTypes["default"].object,
  onClick: _propTypes["default"].func,
  startIndex: _propTypes["default"].number,
  // custom tiny events events
  onIndexChanged: _propTypes["default"].func,
  onTransitionStart: _propTypes["default"].func,
  onTransitionEnd: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  // events
  onInit: _propTypes["default"].func
};
Carousel.defaultProps = {
  onInit: function onInit() {}
};
var _default = Carousel;
exports["default"] = _default;
